import {OrbitTheme} from '../../architecture/orbit-theme.interface';
import {makeTheme} from '../../make-theme';
import {IGeneralColors} from '../../architecture/sections/general-colors.interface';
import {makeCasino888FontsFamily} from './make-casino888-fonts-family';
import {Casino888Icons} from './icons-registry';
import { ThemeName } from '../../architecture/theme-names';
import {createGlobalStyle} from "styled-components";
import React from "react";
import {baseColors} from "./base-colors";
import {IThemeDefinition} from "../../../services/theme/theme-definition.interface";
import {ISdkTheme} from "../../architecture/sections/sdk/sdk-theme.interface";

const GlobalStyles = createGlobalStyle`
    body {
        background-image: url("${props => props.theme.images.texture.toString()}");
        font-family: "888-Orbit", verdana, sans-serif;
        font-weight: 600;
    }
`;



const generalColors: IGeneralColors  = {
    brandPrimary: baseColors.base01,
    brandPrimaryDark: baseColors.base01Dark,
    brandPrimaryLight: baseColors.base01Light,
    brandPrimaryContrast: baseColors.base01Contrast,

    brandSecondary: baseColors.base02,
    brandSecondaryDark: baseColors.base02Dark,
    brandSecondaryLight: baseColors.base02Light,
    brandSecondaryContrast: baseColors.base02Contrast,

    backgroundDark: baseColors.black,
    backgroundMiddleDark: baseColors.gray023,
    background: baseColors.gray033, //bodyBackground
    backgroundLight: baseColors.gray043, //bodyBackgroundLight
    backgroundHover: baseColors.gray033,
    backgroundActive: baseColors.gray033,
    backgroundContrast: baseColors.white,
    iconBackgroundActive: baseColors.base01,
    logoBackground: baseColors.base01,

    textDark: baseColors.black,
    textMiddleDark: baseColors.gray113,
    text: baseColors.gray183,
    textLight: baseColors.white, //bodyText
    textHover: baseColors.white,
    textActive: baseColors.base01,
    textContrast: baseColors.white,
    moneyColor: baseColors.base02,

    boxBorderDark: baseColors.black,
    boxBorderMediumDark: baseColors.gray023,
    boxBorder: baseColors.gray033,
    boxBorderLight: baseColors.gray043,
    boxBorderLighter: baseColors.gray053,
    boxBorderContrast: baseColors.gray113, //bodyInfo
    modalDialogBorder: baseColors.gray113,

    danger: baseColors.base03,
    dangerDark: baseColors.base03Dark,
    dangerLight: baseColors.base03Light,

    buttonDark: baseColors.black,
    buttonLight: baseColors.white,
    buttonInfo: baseColors.gray113,
    buttonWarning: baseColors.base03,

    horizontalLineBackgroundColor: baseColors.gray033,
    horizontalLineBackgroundImage: "",

    gameModeRealBackground: baseColors.gray023,
    gameModeDemoBackground: baseColors.white,



    //bodyText: baseColors.white,
    //bodyInfo: baseColors.gray110,
    //bodyBackground: baseColors.gray020,
    //bodyBackgroundLight: baseColors.gray030,
    //bodyHover: baseColors.gray020,
    //buttonDark: baseColors.black,
    //buttonLight: baseColors.white,
    //buttonInfo: baseColors.gray110,
    //buttonWarning: baseColors.base03,

    //componentBackground: baseColors.gray040,
    //componentTextInfo: baseColors.gray110,
    //componentTextLight: baseColors.white,
    //headerBackground: baseColors.black,
    //headerText: baseColors.base01,
    //modalDialogBorder: baseColors.gray110,
    //gameDescriptionText: baseColors.gray200,
    //intermediatePageGradientBackground: `linear-gradient(to bottom,  ${baseColors.transparent} 46%, ${baseColors.gray020} 100%)`,
    //dividerBottomBorder: baseColors.gray030,
    //dividerTopBorder: baseColors.gray050,
    //navBackground: baseColors.black,
    //navBoxBackground: baseColors.gray040,
    //navItemTextNormal: baseColors.gray110,
    //navItemTextHover: baseColors.white,
    //navItemTextActive: baseColors.base01,
    //filterItemTextActive: baseColors.base02,
    //gameNumberBadgeColor: baseColors.black,
    //profileBoxMessagesBackground: baseColors.gray050,

    //usefulLinkBackground: baseColors.gray040,
    //usefulLinkTextNormal: baseColors.gray110,
    //usefulLinkTextHover: baseColors.white,

    //arenaTitle: baseColors.white,
    //filterSelected: baseColors.base01,
    //filterTop: baseColors.base02Dark,
    //filterMiddle: baseColors.base02Light,
    //filterBottom: baseColors.base01Dark,

    //spinnerBackground: baseColors.black,

    //arenaTitleTopDevider: baseColors.black,
    //arenaTitleBottomDevider: baseColors.gray070,

    //searchLinksBorder: baseColors.gray040,
    //searchResultsBorder: baseColors.gray050,

    //userMenuSectionText: baseColors.gray110,
    //userMenuSectionBg: baseColors.gray040,
    //userMenuTitleText: baseColors.gray110, //!!!
    //userMenuBalanceTitle: baseColors.white,
    //userMenuBalanceColor: baseColors.base02,
    //userMenuBalanceBorder: baseColors.gray020,
    //sideMenuLogoBackground: baseColors.base01,
    //verticalListBackground: baseColors.gray020,
    //jackpotValueColor: baseColors.base02,

    //imageLoadBackgroundColor: baseColors.black,
    //popupHeaderTextColor: baseColors.white,
    //popupHeaderBackgroundColor: baseColors.gray040,
    //popupIconColor: baseColors.base02,
    //popupContentBackgroundColor: baseColors.gray020,
    //filtersTitleColor: baseColors.gray200,
    //filterCheckboxBorder: baseColors.gray070

    // popupIconColor: Color.brandGreen,
};

const FontFamily = makeCasino888FontsFamily();

const sdkTheme: Partial<ISdkTheme> = {
    fontTypes: {
        Main: FontFamily.regular,
        Secondary: FontFamily.bold,
        Type03: FontFamily.body,
        Type04: FontFamily.ultra,
        Type05: FontFamily.light,
        Type06: FontFamily.secondary,
        Type07: "Digital7"
    }
};

const Casino888Theme: OrbitTheme = makeTheme({
    themeName: ThemeName.Casino888,
    generalColors: generalColors,
    fonts: FontFamily,
    themeSpecificIcons: Casino888Icons
});

Casino888Theme.globalStyles = (<GlobalStyles/>);
Casino888Theme.sdk = sdkTheme;


const themeDefinition: IThemeDefinition = {
    shellTheme: Casino888Theme,
    mainContentTheme: Casino888Theme
}

export default themeDefinition;